import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import sRouter from '@/services/sRouter';
import sPackage from '@/services/sPackage';
import { getMenuScheme, visibilityDependOnAcl } from '@/components/Panel/MenuCommon';


// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'PackageUsage',

  props: {
    featureTypes: {
      type: Object,
      default: () => (
        {
          'Promotion': 'Internet', 
          'Package': 'Dodatkowe GB'
        }
      )
    }
  },

  data() {
    return {
      icons: {
        pieChart: require("@/assets/pie-chart.svg"),
        arrow: require("@/assets/arrow-up.svg"),
      },

    }
  },
  computed: {
    ...mapGetters(['servicesList', 'getUsageLoading']),
    startDate() {
      const names = {
        0: "stycznia",
        1: "lutego",
        2: "marca",
        3: "kwietnia",
        4: "maja",
        5: "czerwca",
        6: "lipca",
        7: "sierpnia",
        8: "września",
        9: "października",
        10: "listopada",
        11: "grudnia"
      }
      let currentDate = new Date();
      return "1 " + names[currentDate.getMonth()];
    },
    processedPackages() {
      var index = 0;
      const getUsageLabel = (item) => item.usage_label === undefined ? item.label : item.usage_label;
      return this.servicesList.filter(item => 
        (this.featureTypes[item.feature_type] !== undefined) 
        && item.date !== null && item.is_active && (item.changing_value === undefined || item.changing_value === null || item.changing_value === item.is_active)
      ).sort((a, b) => 
        Math.sign((b.feature_type === 'Promotion') - (a.feature_type === 'Promotion')) * 32 + 
        Math.sign((b.label.search('UE') === -1) - (a.label.search('UE') === -1)) * 16 + 
        Math.sign(b.more_than_one_feature - a.more_than_one_feature) * 8 + 
        Math.sign(moment(b.date) - moment(a.date)) * 4 +
        Math.sign(getUsageLabel(b).length - getUsageLabel(a).length) * 2 + 
        Math.sign(getUsageLabel(a).localeCompare(getUsageLabel(b)))
      ).map((item) => {
        let result = {
          more_than_one_feature: item.more_than_one_feature,
          services_categories_name: item.services_categories_name,
          date: item.date,
          label: item.usage_label === undefined ? item.label : item.usage_label,
          isCountry: item.label.search('UE') === -1,
          activePackageLabel: sPackage.getPackageLabel(item),
          packageLabel: sPackage.getSizeLabels(item),
          packageSize: sPackage.getSizeValues(item),   
          packageUsage: {},
          packageBarWidth: 0, 
          uuid: item.uuid,
          feature_type: item.feature_type,
          index: index++
        };
        result.calulateBarWidth = () => {
          result.packageBarWidth = sPackage.getPackageUsagePercentage(item, result.packageUsage);
        }
        result.checkIfUsageInStore = () => !Object.keys(result.packageUsage).length;
        return result;
      });
    },
    hasAdditionalPackage() {
      let featureNames = Object.keys(this.featureTypes);
      let features = new Set(featureNames);
      features.delete(featureNames[0]);
      return this.processedPackages.filter(item => features.has(item.feature_type)).length > 0;
    },
    processedPackagesByFeatureType() {
      let result = {};
      for (const featureType in this.featureTypes) {
        const filtered = this.processedPackages.filter(item => item.feature_type === featureType);
        if (filtered.length > 0)
          result[featureType] = filtered;
      }
      return result;
    },
    showAddBtn() {
      return visibilityDependOnAcl(this, getMenuScheme()[3]) && !this.hasAdditionalPackage;
    },
    operator() {
      return (localStorage.token === undefined) ? 'PLK' : this.parseJwt(localStorage.token).payload.operator;
    },
    anything_is_changing() {
      return this.servicesList
        .filter(obj => this.featureTypes[obj.feature_type] !== undefined)
        .filter((item) => item.changing_value !== null && item.changing_value !== item.is_active)
        .length;
    },
  },
  mounted() {
    if (window.servicesListPromise === undefined) {
      window.servicesListPromise = this.getServicesList();
      window.servicesListPromise.then(() => {
        setTimeout(() => {
          window.servicesListPromise = undefined;
        }, 3000);
      });
    } 
  },
  created() {
    this.gb2str = sPackage.gb2str;
    this.checkedUsage = Object.fromEntries(Object.keys(this.featureTypes).map(featureType => [featureType, false]));
    this.packageUsage = {};
  },
  methods: {
    ...mapActions(['getServicesList', 'getPackageUsage', 'clearPackageUsage', 'selectCategory']),
    async checkUsage(featureType) {
      const featuredPackages = this.processedPackages.filter(item => item.feature_type === featureType);
      const usages = await this.getPackageUsage(featuredPackages.map(item => {return {feature: item.uuid};}));
      for (let i=0;i<usages.length;i++) {
        const processedPackage = featuredPackages[i];
        processedPackage.packageUsage = usages[i];
        processedPackage.packageBarWidth = sPackage.getPackageUsagePercentage(processedPackage, usages[i]);
      }
      this.checkedUsage[featureType] = true;
      this.$forceUpdate();
    },
    setCheckedUsage(featureType, newValue) {
      this.checkedUsage[featureType] = newValue;
      this.$forceUpdate();
    },
    collapseExtended() {
      this.clearPackageUsage();
    },
    changeUrl(category) {
      sRouter.changeUrl({ name: 'Services' }, this.$router);
      if (category === 'Pakiety') category = 'Internet krajowy';
      this.selectCategory(category);
    },
    parseJwt(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/PackageUsage/component.js